class Nav {
    constructor() {
        this.links = $('.primary__main__link');
        this.body = $('body');
        this.toggleNav = $('#menu-toggle');
        var that = this;
        this.menuContainer = $('.nav-wrapper');


        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);

        window.addEventListener('resize', () => {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });

        $(this.toggleNav).on('click tap', function (e) {
            $(this).toggleClass("hamburger--emphatic js-hamburger is-active");
            if (that.isOpen) {
                that.closeNav();
            } else {
                that.openNav();
            }
        });


        this.links.on('click tap', function (e) {
            that.opensubnav($(this));
            e.preventDefault();
        });

        this.links.on('keydown', function (e) {
            if (e.keyCode === 40) {
                that.opensubnav($(this));
                e.preventDefault();
            }
        });


        $('.primary__close').on('click tap', function (e) {
            that.closesubnav();
            e.preventDefault();
        });

        $(document).on('keydown', function (event) {
            if (event.keyCode === 27) {
                that.closesubnav();
                e.preventDefault();
            }
        });


        $(document).on('keydown', function (event) {
            //primary__sub  open
            const $target = $(event.target);
            if (event.key === 'Tab' && $('.primary__sub.open').length >= 1) {

                if (!$menuContainer.is($target) && !$menuContainer.has($target).length) {
                    that.closesubnav();
                }
            } else {

            }
        });


        let lastNavScrollTop = 0;


    }

    openNav() {
        const that = this;
        that.isOpen = true;
        that.body.addClass('nav-open');
        that.toggleNav.attr('aria-expanded', true);
        //add transition on click to prevent side load animation
        that.menuContainer.addClass('nav-wrapper__open');
    }

    closeNav() {
        const that = this;
        that.isOpen = false;
        that.body.removeClass('nav-open');
        that.toggleNav.attr('aria-expanded', false);
        //add transition on click to prevent side load animation
        that.menuContainer.removeClass('nav-wrapper__open');
    }


    closesubnav(link) {
        var that = this;
        link.parent().removeClass('open');
        that.links.attr('aria-expanded', false);
    }

    opensubnav(link) {
        var that = this;
        let openSubID = link.data('sub');
        let openSub = $('#' + openSubID);
        let isOpen = link.parent().hasClass('open');
        if(isOpen === true ){
            that.closesubnav(link);
        } else {
            link
                .addClass('primary__link--section')
                .attr('aria-expanded', true);

            link.parent().addClass('open');
        }



    }

}
